import React from 'react'
import { MediaQuery } from 'components'
import { css } from 'emotion'
import { MEDIA_QUERY } from 'styles'

const CategoriesTopContainerView = ({
  CategoryListMDElement,
  CategoryListElement,
  ProductListMDElement,
  ProductListElement,
}) => (
  <div className={styles.menu}>
    <div className={styles.border}>
      <div className={styles.categories}>
        <MediaQuery maxWidth={767}>
          {matches => {
            if (matches) {
              return CategoryListMDElement
            }
            return CategoryListElement
          }}
        </MediaQuery>
      </div>
      <MediaQuery maxWidth={767}>
        {matches => {
          if (matches) {
            return ProductListMDElement
          }
          return ProductListElement
        }}
      </MediaQuery>
    </div>
  </div>
)

const styles = {
  menu: css({
    display: 'flex',
    justifyContent: 'center',
  }),
  border: css({
    height: 'calc(100vh - 9rem)',
    width: '90%',
    maxWidth: '120rem',
    display: 'flex',
    padding: '2rem',
    backgroundColor: 'rgba(0,0,0,.7)',
    [MEDIA_QUERY.MD]: {
      padding: 0,
      paddingTop: '1rem',
      height: 'calc(100vh - 13rem)',
      flexDirection: 'column',
      overflowX: 'hidden',
      overflowY: 'scroll',
    },
  }),
  categories: css({
    display: 'flex',
    flexDirection: 'column',
  }),
}
export default CategoriesTopContainerView
